export default __webpack_public_path__ + "images/online-payment/gopay.svg?9b6462b13c3ddbd6331070dc06ec152c1cbeb027ce5bd0938396c7d2bcaa9206";